/**
 * Ícone SVG da logomarca oficial do PIX
 * 
 * Representa o losango com 4 elementos em formato de cruz
 * que compõem a identidade visual do sistema de pagamentos PIX
 */

import { cn } from '@/lib/utils';

interface PixIconProps {
  className?: string;
}

export function PixIcon({ className }: PixIconProps) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-6 w-6', className)}
    >
      {/* Losango PIX - 4 partes formando cruz diagonal */}
      <path
        d="M112.57 391.19c20.56 0 40.09-8.05 54.82-22.76l77.39-77.39c6.23-6.23 16.34-6.23 22.56 0l77.39 77.39c14.73 14.71 34.26 22.76 54.82 22.76h9.79l-98.47 98.47c-32.95 32.94-86.38 32.94-119.32 0l-98.47-98.47h19.49z"
        fill="currentColor"
      />
      <path
        d="M112.57 120.81c20.56 0 40.09 8.05 54.82 22.76l77.39 77.39c6.23 6.23 16.34 6.23 22.56 0l77.39-77.39c14.73-14.71 34.26-22.76 54.82-22.76h9.79l-98.47-98.47c-32.95-32.94-86.38-32.94-119.32 0l-98.47 98.47h19.49z"
        fill="currentColor"
      />
      <path
        d="M488.66 201.55l-55.84-55.84c-1.96 0.51-3.98 0.77-6.01 0.77h-27.26c-13.41 0-26.04 5.23-35.54 14.72l-77.39 77.39c-10.83 10.83-25.06 16.25-39.28 16.25s-28.45-5.42-39.28-16.25l-77.39-77.39c-9.5-9.49-22.13-14.72-35.54-14.72H67.36c-2.03 0-4.05-0.26-6.01-0.77l-55.84 55.84c-32.95 32.94-32.95 86.38 0 119.32l55.84 55.84c1.96-0.51 3.98-0.77 6.01-0.77h27.77c13.41 0 26.04-5.23 35.54-14.72l77.39-77.39c21.66-21.66 56.9-21.66 78.56 0l77.39 77.39c9.5 9.49 22.13 14.72 35.54 14.72h27.26c2.03 0 4.05 0.26 6.01 0.77l55.84-55.84c32.95-32.94 32.95-86.38 0-119.32z"
        fill="currentColor"
      />
    </svg>
  );
}
